module.exports = __webpack_public_path__ + "img/newsIcon.3f9df46f.png";